import { combineReducers } from "redux";

import { bookingListingDetails } from "./reducer.bookingListing"
const bookingListingReducers = combineReducers({
  bookingListingDetails
})
export default bookingListingReducers;
